import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTablesTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    common: {
      table: {
        no_data: 'NO_DATA',
        search: {
          placeholder: 'SEARCH_PLACEHOLDER',
        },
        pagination: {
          from: 'PAGINATION_FROM',
        },
        filter: {
          add_new_filter: 'ADD_NEW_FILTER',
          apply_filter: 'APPLY_FILTER',
          cancel_filter: 'CANCEL_FILTER',
          no_name: 'NO_NAME',
          title: 'FILTER_TITLE',
        },
        no_available_actions: 'NO_AVAILABLE_ACTIONS',
      },
    },
  }));
}
